export default "__VITE_ASSET__DDs1tN8h__"